import { persianLanguage } from "../../constants/persianTerms"

const home = { id: 11, 
    text: `${persianLanguage.word.general.HOME}`, 
    icon: "home",
    className: '', 
    path: "/" }
const goldTradingPlatform = { id: 111, 
        text: `${persianLanguage.phrase.gold.GOLD_TRADING_PLATFORM}`, 
        icon: "home",
        className: '', 
        path: "/trading-platform" }
// const transactions = { id: 12, 
//     text: `${persianLanguage.word.transaction.TRANSACTIONS}`, 
//     icon: "money", 
//     className: '',
//     path: "/transactions" }

const adminTermsAndConditions = {
    id: 26_5, 
    text: `${persianLanguage.phrase.general.TERMS_AND_CONDITIONS}`, 
    icon: "bell", 
    className: 'golden',
    path: "/terms-and-conditions-list" 
}

const termsAndConditions = {
    id: 550,
    text: `${persianLanguage.phrase.general.TERMS_AND_CONDITIONS}`,
    icon: "smalliconslayout",
    className: '', 
    path: "/terms-and-conditions", 
}


const receipt = { id: 13, 
    text: `${persianLanguage.word.receipt.RECEIPT}`, 
    icon: "attach",
    className: '', 
    path: "/receipts" }
const notifications = { id: 14, 
    text: `${persianLanguage.word.notification.NOTIFICATIONS}`, 
    icon: "bell", 
    className: '',
    path: "/notifications" }
// const reports = { id: 15, 
//         text: `${persianLanguage.word.report.REPORT}`, 
//         icon: "bell", 
//         className: '',
//         path: "/reports" }
// const quantities = { id: 21, 
//     text: `${persianLanguage.word.quantityDefinition.QUANTITIES}`, 
//     icon: "smalliconslayout",
//     className: 'golden', 
//     path: "/quantity-definitions"}
// const areas = { id: 22, 
//     text: `${persianLanguage.word.geo.GEO_AREAS}`, 
//     icon: "globe",
//     className: 'golden', 
//     path: "/geo-areas" }
const gold = { id: 23, 
    text: `${persianLanguage.word.gold.GOLD}`, 
    icon: "money",
    className: 'golden', 
    path: "/gold-prices" }
const profiles = { id: 24, 
    text: `${persianLanguage.word.user.PROFILES}`, 
    icon: "group",
    className: 'golden', 
    path: "/profiles" 
}
const adminMessages = { id: 25, 
    text: `${persianLanguage.word.general.MESSAGES} ${persianLanguage.word.general.MANAGER}`, 
    icon: "group",
    className: 'golden', 
    path: "/admin-messages" 
}

const quantities2 = {
    id: 26_1, 
    text: `${persianLanguage.word.quantityDefinition.QUANTITIES}`, 
    icon: "smalliconslayout",
    className: 'golden', 
    path: "/quantity-definitions",
}
const areas2 = { id: 26_2, 
    text: `${persianLanguage.word.geo.GEO_AREAS}`, 
    icon: "globe",
    className: 'golden', 
    path: "/geo-areas" }

const registerFactor = {
    id: 26_3, 
    text: `${persianLanguage.word.general.REGISTER} ${persianLanguage.word.general.FACTOR}`, 
    icon: "bell", 
    className: '',
    path: "/register-factor" 
}

const awaitingTransactions = {
    id: 26_4, 
    text: `${persianLanguage.word.transaction.TRANSACTIONS_AWAITING}`, 
    icon: "bell", 
    className: '',
    path: "/awaiting-transactions" 
}

const goldDataSources = {
    id: 26_5, 
    text: `${persianLanguage.word.general.SOURCES} ${persianLanguage.word.general.RECEIVE} ${persianLanguage.word.general.DATA}`, 
    icon: "smalliconslayout",
    className: 'golden', 
    path: "/gold-data-sources",
}

// const partners = {
//     id: 26_6, 
//     text: `${persianLanguage.word.general.REPRESENTATIVES} ${persianLanguage.word.general.SALE}`, 
//     icon: "smalliconslayout",
//     className: 'golden', 
//     path: "/partners",
// }
const siteSettings = {
    id: 26_7, 
    text: `${persianLanguage.word.general.SETTINGS}`,
    icon: "smalliconslayout",
    className: 'golden',
    path: "/site-settings",
}

const recordData = {
    id: 26,
    text: `${persianLanguage.phrase.general.RECORD_DATA}`,
    className: 'golden', 
    icon: "smalliconslayout",
    items: [
        quantities2,
        areas2,
        registerFactor,
        awaitingTransactions,
        goldDataSources,
        siteSettings,
        // partners,
    ]
}

const adminMessages2 = { id: 30_1, 
    text: `${persianLanguage.word.general.MESSAGES} ${persianLanguage.word.general.MANAGER}`, 
    icon: "group",
    className: 'golden', 
    path: "/admin-messages" 
}

const notifications2 = { id: 30_2, 
    text: `${persianLanguage.word.notification.NOTIFICATIONS}`, 
    icon: "bell", 
    className: '',
    path: "/notifications" }

const messageData = {
    id: 30,
    text: `${persianLanguage.word.general.MESSAGES}`,
    className: 'golden', 
    icon: "smalliconslayout",
    items: [
        adminMessages2,
        notifications2,
    ]
}

const transactions_history = { id: 40_2, 
    text: `${persianLanguage.word.general.HISTORY} ${persianLanguage.word.transaction.TRANSACTIONS}`, 
    icon: "money", 
    className: '',
    path: "/transactions-history" }

const reports2 = {
    id: 40_1, 
    text: `${persianLanguage.word.report.REPORT}`, 
    icon: "bell", 
    className: '',
    path: "/reports" 
}

const adminReportData = {
    id: 40,
    text: `${persianLanguage.word.report.REPORTS}`,
    className: 'golden', 
    icon: "smalliconslayout",
    items: [
        reports2,
        transactions_history,
    ]
}

const userReportData = {
    id: 40,
    text: `${persianLanguage.word.report.REPORTS}`,
    className: 'golden', 
    icon: "smalliconslayout",
    items: [
        reports2,
    ]
}



export const adminNavigationList = [
    home, 
    // transactions, 
    receipt, 
    // notifications, 
    // reports,
    // quantities, 
    // areas, 
    // gold, 
    profiles,
    // adminMessages,
    recordData,
    messageData,
    adminReportData,
]

export const userNavigationList = [
    home, 
    // transactions, 
    receipt, 
    userReportData,
    // notifications, 
    // reports,
]